var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z",
    stroke: "#6172F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 12.6668C12.3675 12.6668 12.666 12.3684 12.666 12.0002C12.666 11.632 12.3675 11.3335 11.9993 11.3335C11.6312 11.3335 11.3327 11.632 11.3327 12.0002C11.3327 12.3684 11.6312 12.6668 11.9993 12.6668Z",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 12.6668C17.0342 12.6668 17.3327 12.3684 17.3327 12.0002C17.3327 11.632 17.0342 11.3335 16.666 11.3335C16.2978 11.3335 15.9993 11.632 15.9993 12.0002C15.9993 12.3684 16.2978 12.6668 16.666 12.6668Z",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 12.6668C7.70087 12.6668 7.99935 12.3684 7.99935 12.0002C7.99935 11.632 7.70087 11.3335 7.33268 11.3335C6.96449 11.3335 6.66602 11.632 6.66602 12.0002C6.66602 12.3684 6.96449 12.6668 7.33268 12.6668Z",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatus);
export default __webpack_public_path__ + "static/media/pending_status.f09b1a0aabee3230d1dfb34e9bff46ff.svg";
export { ForwardRef as ReactComponent };